const SCREEN_FALLBACK_TRANSLATIONS: Record<string, Record<string, string>> = {
  en: {
    "common.separator.or": "OR",
    "common.pageTitle.login": "Login",
    "common.pageTitle.signup": "Sign Up",
    "common.pageTitle.resetPassword": "Reset Password",
    "common.pageTitle.resetPasswordRequest": "Reset your password",
    "common.pageTitle.resetPasswordEmail": "Check your email",
    "common.pageTitle.resetPasswordSuccess": "Password reset successful",
    "common.logoAlt.application": "Application Logo",
    "common.logoAlt.ifit": "IFIT logo",
    "common.logoAlt.ifitUpper": "IFIT Logo",
    "common.buttons.continue": "Continue",
    "common.buttons.signUp": "Sign up",
    "common.buttons.signUpCta": "Sign Up",
    "common.buttons.resetPassword": "Reset Password",
    "common.buttons.resendEmail": "Resend Email",
    "common.buttons.back": "Back",
    "common.buttons.backLower": "back",
    "common.buttons.edit": "Edit",
    "common.links.forgotPassword": "Forgot Password?",
    "common.links.noAccount": "Don't have an account?",
    "common.fields.captcha": "CAPTCHA*",
    "common.fields.passwordRequired": "Password is required",
    "common.fields.passwordAsterisk": "Password*",
    "common.fields.emailAddress": "Email Address",
    "common.fields.phoneNumber": "Phone Number",
    "common.fields.username": "Username",
    "common.fields.phoneOrEmail": "Phone Number or Email Address",
    "common.fields.usernameOrEmail": "Username or Email Address",
    "common.fields.phoneOrUsername": "Phone Number or Username",
    "common.fields.phoneUsernameOrEmail": "Phone, Username, or Email",
    "common.fields.newPassword": "New Password",
    "common.fields.reEnterNewPassword": "Re-enter new Password",
    "common.validation.requiredField": "This field is required",
    "common.validation.maxLength100": "Maximum 100 characters allowed",
    "common.validation.maxLength200": "Maximum 200 characters allowed",
    "common.validation.passwordMinLength":
      "Password must be at least ${minLength} characters",
    "common.validation.passwordConfirmationRequired":
      "Password confirmation is required",
    "common.validation.passwordsDoNotMatch": "Passwords do not match",
    "common.validation.captchaRequired": "Please complete the CAPTCHA",
    "login.header.title": "Sign in to IFIT",
    "loginId.header.title": "Welcome",
    "loginId.header.description": "Log in to iFIT",
    "loginId.social.continueWithPasskey": "Continue with a passkey",
    "loginId.social.continueWithProvider": "Continue with ${provider}",
    "signup.header.title": "Create your Account",
    "signup.country.placeholder": "Select Country",
    "resetPasswordEmail.description":
      "We have sent an email to your registered email address.",
  },
  ko: {
    "common.separator.or": "또는",
    "common.pageTitle.login": "로그인",
    "common.pageTitle.signup": "회원가입",
    "common.pageTitle.resetPassword": "비밀번호 재설정",
    "common.pageTitle.resetPasswordRequest": "비밀번호 재설정",
    "common.pageTitle.resetPasswordEmail": "이메일을 확인해 주세요",
    "common.pageTitle.resetPasswordSuccess": "비밀번호가 재설정되었습니다",
    "common.logoAlt.application": "애플리케이션 로고",
    "common.logoAlt.ifit": "iFIT 로고",
    "common.logoAlt.ifitUpper": "iFIT 로고",
    "common.buttons.continue": "계속",
    "common.buttons.signUp": "회원가입",
    "common.buttons.signUpCta": "회원가입",
    "common.buttons.resetPassword": "비밀번호 재설정",
    "common.buttons.resendEmail": "이메일 다시 보내기",
    "common.buttons.back": "뒤로",
    "common.buttons.backLower": "뒤로",
    "common.buttons.edit": "수정",
    "common.links.forgotPassword": "비밀번호를 잊으셨나요?",
    "common.links.noAccount": "계정이 없으신가요?",
    "common.fields.captcha": "CAPTCHA*",
    "common.fields.passwordRequired": "비밀번호를 입력해 주세요",
    "common.fields.passwordAsterisk": "비밀번호*",
    "common.fields.emailAddress": "이메일 주소",
    "common.fields.phoneNumber": "전화번호",
    "common.fields.username": "사용자 이름",
    "common.fields.phoneOrEmail": "전화번호 또는 이메일 주소",
    "common.fields.usernameOrEmail": "사용자 이름 또는 이메일 주소",
    "common.fields.phoneOrUsername": "전화번호 또는 사용자 이름",
    "common.fields.phoneUsernameOrEmail": "전화번호, 사용자 이름 또는 이메일",
    "common.fields.newPassword": "새 비밀번호",
    "common.fields.reEnterNewPassword": "새 비밀번호 다시 입력",
    "common.validation.requiredField": "필수 입력 항목입니다",
    "common.validation.maxLength100": "최대 100자까지 입력할 수 있습니다",
    "common.validation.maxLength200": "최대 200자까지 입력할 수 있습니다",
    "common.validation.passwordMinLength":
      "비밀번호는 최소 ${minLength}자 이상이어야 합니다",
    "common.validation.passwordConfirmationRequired":
      "비밀번호 확인을 입력해 주세요",
    "common.validation.passwordsDoNotMatch": "비밀번호가 일치하지 않습니다",
    "common.validation.captchaRequired": "CAPTCHA를 완료해 주세요",
    "login.header.title": "iFIT에 로그인",
    "loginId.header.title": "환영합니다",
    "loginId.header.description": "Log in to iFIT",
    "loginId.social.continueWithPasskey": "패스키로 계속하기",
    "loginId.social.continueWithProvider": "${provider}(으)로 계속하기",
    "signup.header.title": "계정을 만들어 주세요",
    "signup.country.placeholder": "국가 선택",
    "resetPasswordEmail.description":
      "등록된 이메일 주소로 이메일을 보냈습니다.",
  },
};

function interpolate(
  value: string,
  params?: Record<string, string | number>
): string {
  if (!params) return value;

  let result = value;
  Object.entries(params).forEach(([key, paramValue]) => {
    result = result.replace(`\${${key}}`, String(paramValue));
  });
  return result;
}

export function getScreenFallbackTranslation(
  locale: string | undefined,
  key: string,
  params?: Record<string, string | number>
): string {
  const lang = (locale || "en").split("-")[0].toLowerCase();
  const template =
    SCREEN_FALLBACK_TRANSLATIONS[lang]?.[key] ||
    SCREEN_FALLBACK_TRANSLATIONS.en[key] ||
    "";
  return interpolate(template, params);
}
